<!-- reset-password-modal.component.html -->
<div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content shadow-lg rounded-3">
      <div class="modal-header bg-primary text-white" style="background-color:#0F172A !important;">
        <h5 class="modal-title">Reset Password</h5>
      </div>
      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <div class="modal-body">
          <div class="mb-3">
            <label for="newPassword" class="form-label">New Password</label>
            <input type="password" id="newPassword" formControlName="newPassword" class="form-control" />
            <div *ngIf="resetForm.get('newPassword')?.touched && resetForm.get('newPassword')?.invalid" class="text-danger">
              Password must meet the required criteria.
            </div>
          </div>

          <div class="mb-3">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
            <input type="password" id="confirmPassword" formControlName="confirmPassword" class="form-control" />
            <div *ngIf="resetForm.hasError('passwordMismatch')" class="text-danger">
              Passwords do not match.
            </div>
          </div>

          <div class="mb-2">
            <small class="text-muted">
              Password must include uppercase, number, and special character(Minimum 8 Characters).
            </small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="resetForm.invalid">Reset Password</button>
        </div>
      </form>
    </div>
  </div>
</div>